var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('parameter-block',{attrs:{"content":_vm.contentArr,"showToggle":true}},[_vm._v("\n  "+_vm._s(_vm.$t('Web.ExpertMode.Items.Versions.Versions'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }